const TOKEN_KEY = 'customs_auth_token'
const PERMS_KEY = 'customs_permissions'
const USER_KEY = 'customs_user'
const AUTH_CHANGED_EVENT = 'customs-auth-changed'

function emitAuthChanged() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(AUTH_CHANGED_EVENT))
  }
}

export function getToken() {
  return sessionStorage.getItem(TOKEN_KEY) || ''
}

export function setAuth({ token, user }) {
  if (token) {
    sessionStorage.setItem(TOKEN_KEY, token)
  }
  const perms = (user && user.permissions) || []
  sessionStorage.setItem(PERMS_KEY, JSON.stringify(perms))
  sessionStorage.setItem(USER_KEY, JSON.stringify(user || {}))
  emitAuthChanged()
}

export function clearAuth() {
  sessionStorage.removeItem(TOKEN_KEY)
  sessionStorage.removeItem(PERMS_KEY)
  sessionStorage.removeItem(USER_KEY)
  emitAuthChanged()
}

export function getPermissions() {
  try {
    const s = sessionStorage.getItem(PERMS_KEY)
    return s ? JSON.parse(s) : []
  } catch (e) {
    return []
  }
}

export function hasPerm(code) {
  const p = getPermissions()
  if (p.includes('*')) {
    return true
  }
  return p.includes(code)
}

/** 上传管理侧栏/批量上传页：仅上传相关码（报关单文件查询属报关管理，见 menu.declarations.batch_file_query） */
export const DECLARATION_UPLOAD_PERMS = [
  'menu.declaration_uploads',
  'menu.declaration_uploads.batch',
  'menu.declaration_uploads.links',
  'declaration_uploads.read',
  'declaration_uploads.write',
]

export function hasAnyPerm(codes) {
  if (!Array.isArray(codes)) {
    return false
  }
  return codes.some((c) => hasPerm(c))
}

export function canAccessDeclarationUploads() {
  return hasAnyPerm(DECLARATION_UPLOAD_PERMS)
}

/**
 * 与后端 RbacGate 上传写操作菜单兼容一致：显式 declaration_uploads.write，
 * 或对应子菜单码（仅挂菜单、未挂「上传与维护关联」时也能点上传/删关联/重发微秘书等）。
 *
 * @param {'batch'|'links'|'fileQuery'} kind 批量上传 | 关联数据 | 报关单文件查询
 */
export function canDeclarationUploadsWrite(kind) {
  if (hasPerm('*') || hasPerm('declaration_uploads.write')) {
    return true
  }
  if (hasPerm('menu.declaration_uploads')) {
    return true
  }
  if (kind === 'batch' && hasPerm('menu.declaration_uploads.batch')) {
    return true
  }
  if (kind === 'links' && hasPerm('menu.declaration_uploads.links')) {
    return true
  }
  if (kind === 'fileQuery' && hasPerm('menu.declarations.batch_file_query')) {
    return true
  }
  return false
}

export function getStoredUser() {
  try {
    const s = sessionStorage.getItem(USER_KEY)
    return s ? JSON.parse(s) : null
  } catch (e) {
    return null
  }
}

export function onAuthChanged(listener) {
  if (typeof window === 'undefined' || typeof listener !== 'function') return () => {}
  window.addEventListener(AUTH_CHANGED_EVENT, listener)
  return () => window.removeEventListener(AUTH_CHANGED_EVENT, listener)
}
